import type { ComboSavings } from "@/domain/suggestions";
import { centsToReais, formatBRL } from "@/lib/format-brl";
import { formatSuggestionMessage } from "@/lib/i18n/suggestions-messages";
import { Badge, InteractiveCard, Text } from "@/components/ui";
import { TagIcon } from "@/icons";

/**
 * "Leve o combo e economize R$ X" — computed here from the catalog (see
 * `findBestComboSavings`), never a merchant-configured suggestion. Opens the
 * combo's OWN item detail; it never mutates the cart directly, since the
 * combo may still carry other required choices the customer must make.
 */
export function ComboSavingsCard({ combo, onOpen }: { combo: ComboSavings; onOpen: (comboItemOfferId: string) => void }) {
  const savingsLabel = formatBRL(centsToReais(combo.savingsCents));

  return (
    <li className="w-combo shrink-0 snap-start">
      <InteractiveCard
        variant="tinted"
        tone="primary"
        padding="sm"
        data-testid={`combo-savings-card-${combo.comboItemOfferId}`}
        onClick={() => onOpen(combo.comboItemOfferId)}
        className="flex h-full w-full flex-col items-start gap-1.5"
      >
        <Badge variant="solid" tone="primary" shape="pill" icon={TagIcon}>
          Combo
        </Badge>
        <Text size="sm" weight="semibold" leading="snug" tone="default">
          {formatSuggestionMessage("comboCta", savingsLabel)}
        </Text>
      </InteractiveCard>
    </li>
  );
}
